import React from 'react';
import { Link } from 'react-router-dom';
import { QrCode, ArrowLeft } from 'lucide-react';

const MentionsLegales = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white border-b border-gray-100">
        <div className="max-w-4xl mx-auto px-4 py-4">
          <Link to="/" className="inline-flex items-center gap-2 text-gray-600 hover:text-gray-900">
            <ArrowLeft className="h-4 w-4" />
            Retour à l'accueil
          </Link>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-4 py-12">
        <div className="flex items-center gap-3 mb-8">
          <div className="h-12 w-12 rounded-xl bg-gradient-to-br from-orange-500 to-orange-600 flex items-center justify-center">
            <QrCode className="h-7 w-7 text-white" />
          </div>
          <h1 className="font-heading text-3xl font-bold text-gray-900">Mentions légales</h1>
        </div>

        <div className="bg-white rounded-2xl shadow-soft p-8 space-y-8">
          <section>
            <h2 className="font-heading text-xl font-semibold text-gray-900 mb-4">1. Éditeur du site</h2>
            <div className="text-gray-600 space-y-2">
              <p><strong>Raison sociale :</strong> SARL DEALRUN</p>
              <p><strong>SIRET :</strong> 895 350 783 00018</p>
              <p><strong>Forme juridique :</strong> Société à Responsabilité Limitée (SARL)</p>
              <p><strong>Adresse :</strong> La Réunion, France</p>
              <p><strong>Email :</strong> <a href="mailto:contact@dealrun.re" className="text-orange-500 hover:underline">contact@dealrun.re</a></p>
              <p><strong>Téléphone :</strong> <a href="tel:0693463628" className="text-orange-500 hover:underline">06 93 46 36 28</a></p>
            </div>
          </section>

          <section>
            <h2 className="font-heading text-xl font-semibold text-gray-900 mb-4">2. Directeur de la publication</h2>
            <p className="text-gray-600">Le directeur de la publication est le représentant légal de la SARL DEALRUN.</p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-semibold text-gray-900 mb-4">3. Hébergement</h2>
            <div className="text-gray-600 space-y-2">
              <p>Le site ZOTMENU est hébergé par :</p>
              <p><strong>Emergent</strong></p>
              <p>Plateforme d'hébergement cloud</p>
            </div>
          </section>

          <section>
            <h2 className="font-heading text-xl font-semibold text-gray-900 mb-4">4. Propriété intellectuelle</h2>
            <p className="text-gray-600">
              L'ensemble du contenu du site ZOTMENU (textes, images, logos, icônes, sons, logiciels, etc.) 
              est la propriété exclusive de SARL DEALRUN ou de ses partenaires. Toute reproduction, représentation, 
              modification, publication, adaptation de tout ou partie des éléments du site, quel que soit le moyen 
              ou le procédé utilisé, est interdite, sauf autorisation écrite préalable de SARL DEALRUN.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-semibold text-gray-900 mb-4">5. Données personnelles</h2>
            <p className="text-gray-600">
              Conformément au Règlement Général sur la Protection des Données (RGPD) et à la loi Informatique 
              et Libertés, vous disposez d'un droit d'accès, de rectification, de suppression et d'opposition 
              aux données personnelles vous concernant. Pour exercer ces droits, vous pouvez nous contacter à 
              l'adresse : <a href="mailto:contact@dealrun.re" className="text-orange-500 hover:underline">contact@dealrun.re</a>
            </p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-semibold text-gray-900 mb-4">6. Cookies</h2>
            <p className="text-gray-600">
              Le site ZOTMENU utilise des cookies pour améliorer l'expérience utilisateur et analyser 
              le trafic. En continuant à naviguer sur ce site, vous acceptez l'utilisation de cookies 
              conformément à notre politique de confidentialité.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-semibold text-gray-900 mb-4">7. Limitation de responsabilité</h2>
            <p className="text-gray-600">
              SARL DEALRUN s'efforce d'assurer l'exactitude et la mise à jour des informations diffusées 
              sur ce site. Toutefois, elle ne peut garantir l'exactitude, la précision ou l'exhaustivité 
              des informations mises à disposition sur ce site.
            </p>
          </section>
        </div>

        <p className="text-center text-gray-500 text-sm mt-8">
          Dernière mise à jour : Janvier 2025
        </p>
      </main>
    </div>
  );
};

export default MentionsLegales;
